import React from "react";
import Routes from "./Routes";
import { Toaster } from "react-hot-toast";
import { ThemeProvider } from "components/ThemeProvider";

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <Toaster position="top-center" />
      <Routes />
    </ThemeProvider>
  );
}

export default App;
